import service from '@/utils/server';

const modName='/int/hikVehicleEntrance/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/int/hikVehicleEntrance/api/index.js